import React, { Component } from "react";
import { getYearDifference, creatSkillsYearsObj } from "./Utility";
import skills from "./data/skills.json";
import { isMobile } from "react-device-detect";

class Skills extends Component {
  constructor() {
    super();

    this.state = {
      open: false,
      barWidth: 0,
      skillName: ""
    };
  }
  componentDidMount() {
    const skillsArr = creatSkillsYearsObj(skills, this.props.maxYears);
    this.setState({
      skillsArr,
      open: this.props.view === "desktop" ? true : false,
      desktop: this.props.view === "desktop" ? true : false,
      mobile: this.props.view === "desktop" ? false : true
    });
  }

  renderChart = () => {
    const dt2 = new Date().getTime();
    return skills.map((skill, i) => {
      const dt1 = new Date(skill.startDate).getTime();
      const diff = getYearDifference(dt1, dt2);
      return (
        <div key={`skill-${i}`}>
          <div className="skill-info--container">
            <div className="skill-name"> {skill.name}</div>
            <div className="skill-exp">{diff} years</div>
          </div>
          <div className="skill-bar">
            <div
              className="experience-bar"
              style={{
                width: (diff / 6) * this.state.barWidth,
                backgroundColor: skill.color
              }}
            />
          </div>
        </div>
      );
    });
  };

  handleBoxClick = e => {
    const skillName = e.currentTarget.attributes["data-tag"].value;
    this.setState({
      skillName
    });
  };
  buildColumn = arr => {
    return arr.map((e, i) => {
      return (
        <div
          key={`buildColumn-${i}`}
          className="skill-box--wrapper animated bounce"
          onClick={this.handleBoxClick}
          data-tag={e.name}
        >
          {isMobile ? (
            <p className="mobile-device">{e.name}</p>
          ) : (
            <i className={`skill-logo  ${e.class}`} />
          )}
        </div>
      );
    });
  };

  buildSkills = () => {
    return this.state.skillsArr
      ? this.state.skillsArr.map((e, i) => {
          return (
            <div key={`${e.name}-${i}`} className="skills-year-row">
              {this.buildColumn(e.skills)}
              <div className="skill-years-x-axis--box">{e.year}</div>
            </div>
          );
        })
      : null;
  };

  renderSkills = () => {
    let table = [];
    for (let i = 0; i <= this.props.maxYears; i++) {
      table.push(i);
    }
    return table.map(t => {
      return <div className="skill-years-x-axis--box">{t}</div>;
    });
  };

  handleHeaderClick = () => {
    const { open } = this.state;
    if (this.state.desktop) {
      return;
    } else {
      this.setState({ open: !open, skillName: "" });
    }
  };

  buildForSafari() {
    return skills.map((e, i) => {
      const years = e.experience === 1 ? "year" : "years";
      return (
        <li key={`${e}-${i}`} className="skills-list-item list-group-item">
          <div className="skills-list-item--container">
            <p>{e.name}</p>
            <p>
              {this.state.mobile
                ? `${e.experience} ${years}`
                : `${e.experience} `}
            </p>
          </div>
        </li>
      );
    });
  }

  render() {
    const columns = `repeat(${this.props.maxYears}, 1fr)`;
    const { open, mobile } = this.state;
    const isSafari = window.safari !== undefined;
    const iOS =
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

    return (
      <div className="skills-section--container content-section" ref="div-ref">
        <div
          className={`header--wrapper ${open ? "isShowing" : ""}`}
          onClick={this.handleHeaderClick}
        >
          <div className="dropdown-indicator">
            {mobile ? (open ? "-" : "+") : null}
          </div>

          <div className="collapse--header-text">Skills</div>
        </div>
        <div
          className={`collape-text skill-section--wrapper ${
            open ? "show" : ""
          } ${this.state.desktop ? "desktop" : ""}`}
        >
          <div className="mobile-box-skill--name">{this.state.skillName}</div>
          <div
            className="skill-years-x-axis--container"
            style={{ gridTemplateColumns: columns }}
          >
            {isSafari ? null : this.buildSkills()}
          </div>
          {isSafari ? null : (
            <div className="skill-years-x-axis-description">
              Years of Experience
            </div>
          )}
          <div>
            <ul className="list-skills--container">
              {mobile ? null : !isSafari ? null : (
                <li className="skills-list-item">
                  <div className="skills-list-item--container">
                    <p>Technology</p>
                    <p>Years of Experience</p>
                  </div>
                </li>
              )}
              {isSafari || iOS ? this.buildForSafari() : null}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default Skills;
